import {
   ReceptionServiceWithPractitionersSimple,
   ReceptionServiceWithPractitionersSimpleQuery,
} from '@dreryk/egabinet-private-medical-service-frontend-api';
import { PractitionerId } from '@dreryk/egabinet-personnel-published-language-api';

import { CqrsQueryPerformResult, performCqrsQuerySearch } from '@dreryk/command-query-react-common';
import { Slot, TextPattern } from '@dreryk/watermelon';

export const triggerLabelExtractor = (receptionService: ReceptionServiceWithPractitionersSimple): string =>
   receptionService.name;

export const createReceptionServiceWithPractitionerSearchCreator = (practitionerId: number | undefined) => (
   searchText: string | null
) => {
   return async (): CqrsQueryPerformResult<ReceptionServiceWithPractitionersSimple[]> =>
      performCqrsQuerySearch<ReceptionServiceWithPractitionersSimple>(() => {
         const receptionServiceWithPractitionersSimpleQuery = new ReceptionServiceWithPractitionersSimpleQuery();
         receptionServiceWithPractitionersSimpleQuery.practitionersIds = Slot.emptyIfNull(
            practitionerId ? [PractitionerId.of(practitionerId)] : null
         );
         receptionServiceWithPractitionersSimpleQuery.name = searchText
            ? TextPattern.anywhereIgnoreCase(searchText)
            : undefined;
         return receptionServiceWithPractitionersSimpleQuery;
      });
};
